import React from "react";
import styled, { withTheme } from "styled-components";

const GoalRow = styled.div`
  margin-bottom: 10px;
  font-weight: 600;
`;

const GoalHeader = styled.div`
  display: inline-block;
  background: ${(props) => props.theme?.whiteSmoke};
  padding: 10px;
  width: 100%;
`;

const GoalTitle = styled.div`
  float: left;
  color: ${(props) => props.theme?.geminiGray};
`;

const GoalOrigin = styled.div`
  float: right;
  color: ${(props) => props.color || "#000000"};
`;

const GoalBody = styled.div`
  color: ${(props) => props.theme?.geminiGray};
  background: ${(props) => props.bgColor || "#000000"};
  padding: 10px;
  width: 100%;
  clear: both;
  margin-top: -6px;
  display: inline-block;
`;

const GoalLabel = styled.div`
  float: left;
  color: ${(props) => props.color || "#000000"};
`;

const GoalValue = styled.div`
  float: right;
  color: ${(props) => props.theme?.nero};
`;

const TargetItem = (props) => {
  const { title, origin, color, bgColor, label, value } = props;

  return (
    <GoalRow className="goal-item" data-testid="target-item">
      <GoalHeader data-testid="goal-header">
        <GoalTitle data-testid="goal-title">{title}</GoalTitle>
        <GoalOrigin {...{ color }} data-testid="goal-origin">
          {origin}
        </GoalOrigin>
      </GoalHeader>
      <GoalBody {...{ bgColor }} data-testid="goal-body">
        <GoalLabel {...{ color }} data-testid="goal-label">
          {label}
        </GoalLabel>
        <GoalValue data-testid="goal-value">{value}</GoalValue>
      </GoalBody>
    </GoalRow>
  );
};

export default withTheme(TargetItem);
